const type = 'STATEMENTS_STARTED_SCROLLING';

const statementsStartedScrolling = () => ({
  type,
});

export { type };
export default statementsStartedScrolling;
